import React from 'react';
import PageHeader from './page_header/PageHeader';
import { SectionWithChildren, FreeDiv, Columns, Divider } from './canvas-components/LayoutMisc';
import FlexContainer from './canvas-components/FlexContainer';
import GridContainer from './canvas-components/GridContainer';
import { StatCard, DataTable, BarChart, LineChart, PieChart, Badge } from './canvas-components/DataComponents';
import { InputField, Dropdown, DatePicker, TextArea, FileUpload, SearchBar } from './canvas-components/FormComponents';
import { Button, TextBlock, AlertBox, EmptyState, ImageBlock, RichHtml } from './canvas-components/ContentComponents';
import { libFind } from './constants.jsx';

export default function CanvasRenderer({ comp, onChildSelect, selectedChildId }) {
  if (!comp) return null;

  const containerProps = { comp, onChildSelect, selectedChildId };

  const fallback = (
    <div style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#9CA3AF',
      fontSize: 12,
      border: '1px dashed #E2E5EA',
      borderRadius: 8,
    }}>
      {libFind(comp.type).label}
    </div>
  );

  switch (comp.type) {
    // ✅ Containers (consistent handling)
    case 'section':        return <SectionWithChildren {...containerProps} />;
    case 'flex_row':
    case 'flex_col':       return <FlexContainer {...containerProps} />;
    case 'grid_container': return <GridContainer {...containerProps} />;
    case 'free_div':       return <FreeDiv {...containerProps} />;
    case 'columns':        return <Columns {...containerProps} />;

    // Layout (no children)
    case 'page_header': return <PageHeader comp={comp} />;
    case 'divider':     return <Divider comp={comp} />;

    // Data
    case 'stat_card':  return <StatCard comp={comp} />;
    case 'data_table': return <DataTable comp={comp} />;
    case 'chart_bar':  return <BarChart comp={comp} />;
    case 'chart_line': return <LineChart comp={comp} />;
    case 'chart_pie':  return <PieChart comp={comp} />;
    case 'badge':      return <Badge comp={comp} />;

    // Forms
    case 'fb_input':    return <InputField comp={comp} />;
    case 'fb_dropdown': return <Dropdown comp={comp} />;
    case 'fb_date':     return <DatePicker comp={comp} />;
    case 'fb_textarea': return <TextArea comp={comp} />;
    case 'fb_file':     return <FileUpload comp={comp} />;
    case 'search_bar':  return <SearchBar comp={comp} />;

    // Buttons
    case 'btn_primary':
    case 'btn_secondary':
    case 'btn_danger': return <Button comp={comp} />;

    // Content
    case 'text_block':  return <TextBlock comp={comp} />;
    case 'alert_box':   return <AlertBox comp={comp} />;
    case 'empty_state': return <EmptyState comp={comp} />;
    case 'image_block': return <ImageBlock comp={comp} />;
    case 'rich_html':   return <RichHtml comp={comp} />;

    default: return fallback;
  }
}
